module.exports = __webpack_public_path__ + "static/media/painting.7d03942d.jpg";